import React, { useState, useEffect } from 'react';
import { limpiarCedula } from '../../components/limpiarCedula';
import { FECHA_NAC_MIN, FECHA_NAC_MAX } from '../../components/fechaNacimiento';
import axios from '../../axiosConfig';
import { Form, Button } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Select from 'react-select/async';
import { useLoading } from '../../components/LoadingContext';
import { ToastContainer, toast } from 'react-toastify';
import SelectComponent from '../../components/SelectComponent';
import { cohortesActivas } from '../../components/cohorteUtils';
import { Card, Row, Col } from 'react-bootstrap'; 
import { Modal, Table } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons

const userId = parseInt(localStorage.getItem('user'));  // ID del usuario logueado



const InscribirIniciativas = () => {
    const { id } = useParams();
    const [cedula, setCedula] = useState('');
    const [datos, setDatos] = useState(null);
    const [curso, setCurso] = useState(null);
    const [error, setError] = useState('');
    const { setLoading } = useLoading();
    const navigate = useNavigate();
    const [selectVisible, setSelectVisible] = useState(false);  // Control de la visibilidad de los selectores
    const [showModal, setShowModal] = useState(false);  // Estado para mostrar/ocultar modal
    const handleCloseModal = () => setShowModal(false); // Cierra el modal
    const [patrocinantes, setPatrocinantes] = useState([]); // Estado para lista de patrocinantes
    const [totalPages, setTotalPages] = useState(1);    // Total de páginas
    const [cedulaError, setCedulaError] = useState('');  // Estado para el mensaje de error si ya está inscrito
    const [isCedulaValid, setIsCedulaValid] = useState(true); // Estado para manejar si la cédula es válida
    const [formErrors, setFormErrors] = useState({}); // Estado para almacenar los mensajes de error
    const [patrocinanteSeleccionado1, setPatrocinanteSeleccionado1] = useState(null);
    const [patrocinanteSeleccionado2, setPatrocinanteSeleccionado2] = useState(null);
    const [patrocinanteSeleccionado3, setPatrocinanteSeleccionado3] = useState(null);
    const [currentPatrocinante, setCurrentPatrocinante] = useState(null); // Para saber cuál botón abrió el modal
    const [paginatedPatrocinantes, setPaginatedPatrocinantes] = useState([]); // Patrocinantes en la página actual
      const [patrocinanteName, setPatrocinanteName] = useState(''); // Estado para guardar el código del curso
    

    const [currentPagePatrocinantes, setCurrentPagePatrocinantes] = useState(1);
    const userRole = localStorage.getItem('role');
    
    const [filterOptions, setFilterOptions] = useState({
        cohorteOptions: [],
        periodoOptions: [],
        nivelInstruccionOptions: [],
        estadoOptions: [],
        generoOptions: [],
        grupoOptions: [],
        nacionalidadOptions: [],
        procedenciaOptions: [],
        superatecOptions: [],  
        iniciativaOptions:[],
    });
      const [filterOptions2, setFilterOptions2] = useState({
        nivelInstruccionOptions: [],
        estadoOptions: [],
        generoOptions: [],
        grupoOptions: [],
        nacionalidadOptions: [],
        procedenciaOptions: [],
        superatecOptions: [],  
    });
    const [formData, setFormData] = useState({
        cohorte: '',
        periodo_id: '',
        descripcion:'',
        iniciativa_id:'',
        datos_participante_fat_id:'',
        patrocinante_id:id,
        grupo:'',
        completado:false,
    });
    const [filas, setFilas] = useState([
        {
           cohorte: '',
        periodo_id: '',
        descripcion:'',
        iniciativa_id:'',
        datos_participante_fat_id:'',
        patrocinante_id:id,
        grupo:'',
        completado:false,
        },
        {
             cohorte: '',
        periodo_id: '',
        descripcion:'',
        iniciativa_id:'',
        datos_participante_fat_id:'',
        patrocinante_id:id,
        grupo:'',
        completado:false,
          },
          {
            cohorte: '',
        periodo_id: '',
        descripcion:'',
        iniciativa_id:'',
        datos_participante_fat_id:'',
        patrocinante_id:id,
        grupo:'',
        completado:false,
          },
       
      ]); 
      
    
      // Agregar nueva fila
      const agregarFila = () => {
        setFilas([
          ...filas,
          {
            cohorte: '',
        periodo_id: '',
        descripcion:'',
        iniciativa_id:'',
        datos_participante_fat_id:'',
        patrocinante_id:id,
        grupo:'',
        completado:false,
            bloqueado: false // Bloquear edición

          },
        ]);
      };
    
      // Eliminar la última fila
      const eliminarFila = () => {
        if (filas.length > 1) {
          setFilas(filas.slice(0, -1)); // Remueve la última fila
        }
      };
    


 

    const [filtrosPatrocinante, setFiltrosPatrocinante] = useState({
        rif_cedula:'',
        nombre_patrocinante: '',
    });
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    

    const handleFilterPatrocinantesChange = (e) => {
        const { name, value } = e.target;
        setFiltrosPatrocinante(prev => ({ ...prev, [name]: value }));
      };
      
      const handlePatrocinantesPageChange = async (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            await getAllPatrocinantes(newPage);
        }
      };

    const handleSeleccionarPatrocinante = (patrocinante) => {
        if (currentPatrocinante === 1) {
            setPatrocinanteSeleccionado1(patrocinante);
            setFormData(prevData => ({ ...prevData, patrocinante_id: patrocinante.id }));
        } else if (currentPatrocinante === 2) {
            setPatrocinanteSeleccionado2(patrocinante);
            setFormData(prevData => ({ ...prevData, patrocinante_id2: patrocinante.id }));
        } else if (currentPatrocinante === 3) {
            setPatrocinanteSeleccionado3(patrocinante);
            setFormData(prevData => ({ ...prevData, patrocinante_id3: patrocinante.id }));
        }
        handleCloseModal();
    };
    
    

    useEffect(() => {
        setLoading(true);
        Promise.all([fetchIniciativa(),handleSeleccionar(),handleSeleccionar2()]).finally(() => {
            setLoading(false);
        });
    }, [id]);
    

    const fetchIniciativa = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/patrocinantes/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setCurso(response.data);
        } catch (error) {
            console.error('Error fetching curso:', error);
            setError('Error fetching curso');
        }
    };

  
const handleCedulaSearch = async (index) => {
  const cedula = filas[index]?.cedula_identidad?.toString().trim();
  if (!cedula) return;

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const patchRow = (patch) => setFilas(prev => {
    const next = [...prev];
    next[index] = { ...next[index], ...patch };
    return next;
  });

  const setNotFound = () =>
    patchRow({
      errorMensaje: 'Cédula no encontrada. Complete los datos manualmente.',
      superatec: false,
      bloqueado: false,
      datos_participante_fat_id: null,
    });

  try {
    // 1) Buscar en datos_participantes_fat
    let r1;
    try {
      r1 = await axios.get(`/identificacion-iniciativas/${cedula}`, { headers });
    } catch (e) {
      // si es 404 lo tratamos como "no encontrado", otros errores los propagamos
      if (e?.response?.status !== 404) throw e;
    }

    const d1 = r1?.data;
    if (d1 && d1.id) {
      patchRow({
        nombres: d1.nombres,
        apellidos: d1.apellidos,
        fecha_nacimiento: d1.fecha_nacimiento,
        genero_id: d1.genero_id,
        direccion: d1.direccion,
        nivel_instruccion_id: d1.nivel_instruccion_id,
        email: d1.email,
        tlf_casa: d1.tlf_casa,
        datos_participante_fat_id: d1.id,
        superatec: true,
        bloqueado: true,
        errorMensaje: '',
      });
      return;
    }

    // 2) Fallback: buscar en datos_identificacion
    let r2;
    try {
      r2 = await axios.get(`/identificacion/${cedula}`, { headers });
    } catch (e2) {
      if (e2?.response?.status !== 404) throw e2;
    }

    const d2 = r2?.data;
    if (d2) {
      patchRow({
        nombres: d2.nombres,
        apellidos: d2.apellidos,
        fecha_nacimiento: d2.fecha_nacimiento,
        genero_id: d2.genero_id,
        direccion: d2.direccion,
        nivel_instruccion_id: d2.nivel_instruccion_id,
        email: d2.direccion_email,  // <- mapeo distinto
        tlf_casa: d2.telefono_casa, // <- mapeo distinto
        datos_participante_fat_id: null,
        superatec: false,
        bloqueado: false,
        errorMensaje: '',
      });
      return;
    }

    // 3) No está en ninguna
    setNotFound();
  } catch (err) {
    patchRow({
      errorMensaje: 'Error al buscar la cédula',
      superatec: false,
      bloqueado: false,
    });
    console.error(err);
  }
};

    
    
    const handleCedulaInputChange = (event, index) => {
        let nuevoEstadoFilas = [...filas];
        let inputValue = limpiarCedula(event.target.value); // Dígitos (máx. 9) o cédula falsa F + dígitos
        nuevoEstadoFilas[index].cedula_identidad = inputValue;
        nuevoEstadoFilas[index].errorMensaje = "";
        setFilas(nuevoEstadoFilas);
    };
    
    const limpiarFila = (index) => {
        let nuevoEstadoFilas = [...filas];
        nuevoEstadoFilas[index] = {
            cedula_identidad: "",
            nombres: "",
            apellidos: "",
            fecha_nacimiento: "",
            genero_id: "",
            direccion: "",
            nivel_instruccion_id: "",
            direccion_email: "",
            tlf_casa: "",
            superatec: false,
        };
        setFilas(nuevoEstadoFilas);
    };
    const handleSeleccionar = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/select-inc`, {
                headers: { Authorization: `Bearer ${token}` }
            });
    
            const { cohorte, periodo,grupo,iniciativa } = response.data;
    
            // Guardar las opciones en el estado de filterOptions
            setFilterOptions({
                cohorteOptions: cohorte,
                periodoOptions: periodo,
                grupoOptions:grupo,
                iniciativaOptions:iniciativa,
            });
    
            setSelectVisible(true);  // Mostrar los selectores
        } catch (error) {
            console.error('Error fetching filter options:', error);
        }
    };
    const handleSeleccionar2 = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/filter-datos`, {
                headers: { Authorization: `Bearer ${token}` }
            });
    
            const {nivel_instruccion,estado,genero,grupo_prioritario,nacionalidad,procedencia,superatec} = response.data;
    
            // Guardar las opciones en el estado de filterOptions
            setFilterOptions2({
                nivelInstruccionOptions: nivel_instruccion,
                estadoOptions: estado,
                generoOptions: genero,
                grupoOptions:grupo_prioritario,
                nacionalidadOptions:nacionalidad,
                procedenciaOptions:procedencia,
                superatecOptions:superatec,
    
            });
    
            console.log("superatec",filterOptions.superatecOptions);
            console.log("procedencia",filterOptions.procedenciaOptions);
    
    
            setSelectVisible(true);  // Mostrar los selectores
        } catch (error) {
            console.error('Error fetching filter options:', error);
        }
    };

    
    
    

    const getAllPatrocinantes = async (page = 1) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/patrocinantes-paginate`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filtrosPatrocinante, page }, // Incluye `page` en los parámetros
            });
    
            const { data, last_page, current_page } = response.data.patrocinantes;
    const patrocinante = response.data;
  
        if (patrocinante) {
          setPatrocinanteName(patrocinante.nombre_patrocinante);
        } 
            // Actualizar el estado
            setPaginatedPatrocinantes(data); // Datos de la página actual
            setCurrentPagePatrocinantes(current_page); // Página actual
            setTotalPages(last_page); // Total de páginas
            setPatrocinantes(data);
        } catch (error) {
            console.error('Error fetching users:', error);
            toast.error('Error fetching data');
            setPaginatedPatrocinantes([]); // Limpia los datos en caso de error
            setPatrocinantes([]);
        }
    };

  
        const handleOpenModal = () => {
            getAllPatrocinantes(); // Cargar todos los patrocinantes
            setShowModal(true); // Mostrar el modal
        };


       const handleInscripcion = async () => {

        setLoading(true);
  // 1) separar los que NO son superatec (hay que crearlos primero)
  const participantesNoSuperatec = filas.filter(f => !f.superatec && f.cedula_identidad);
  const todosParticipantes = [...filas];

  try {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    // 2) Crear en datos_participantes_fat los que no son superatec
    if (participantesNoSuperatec.length > 0) {
      const resp = await axios.post(`/part-iniciativas`, { participantes: participantesNoSuperatec }, { headers });

      const creados = resp?.data?.participantes ?? resp?.data ?? [];
      creados.forEach((np) => {
        const idx = todosParticipantes.findIndex(f => f.cedula_identidad === np.cedula_identidad);
        if (idx !== -1) {
          todosParticipantes[idx].datos_participante_fat_id = np.id;
          // si quieres, márcalos ya como superatec porque ya tienen ID
          todosParticipantes[idx].superatec = true;
        }
      });

      setFilas([...todosParticipantes]);
    }

    // 3) Preparar payload de inscripciones (TODOS)
    const inscripciones = todosParticipantes.map(p => ({
      cohorte:        formData.cohorte,
      periodo_id:     formData.periodo_id,
      iniciativa_id:  formData.iniciativa_id,
      grupo:          formData.grupo,
      patrocinante_id: formData.patrocinante_id ?? id, // usa el que corresponda
      descripcion:    formData.descripcion ?? null,
      datos_participante_fat_id: p.datos_participante_fat_id,
    }));

    // (opcional) advertir si falta ID en alguno
    const sinId = inscripciones.filter(x => !x.datos_participante_fat_id);
    if (sinId.length) {
      console.warn('Participantes sin datos_participante_fat_id:', sinId.map((x, i) => todosParticipantes[i]?.cedula_identidad));
      // si quieres bloquear el envío:
      // toast.error('Hay participantes sin ID de datos_participante_fat'); return;
    }

    // 4) Inscribir
    await axios.post(`/insc-iniciativa`, { inscripciones }, { headers });

    toast.success("Participantes inscritos con éxito");
    setLoading(false);
    navigate(`/insc-iniciativas/${id}`);
  } catch (error) {
    console.error('Error en la inscripción:', error);
    toast.error("Error al inscribir");
  }
};

        

    return (
        <div className="row" style={{ marginTop: '50px' }}>
        <div className="col-lg-11 mx-auto"> {/* Centrado del contenido */}
        <Form.Group controlId="cedula" className="custom-gutter" >
          <div className="card-box" style={{ padding: '20px', width: '100%', margin: '0 auto' }}>
            <h1>Inscripción a Iniciativa de   {curso && `  ${curso.nombre_patrocinante}`} </h1>
            <div>


            </div>
           
                <div className="mt-3">
                    <Row className="g-2">
                        <Col md={6}>
                    {/* Cohorte Selector */}
                    {formErrors.cohorte && (
                    <div className="text-danger">{formErrors.cohorte}</div>
                )}
                    <SelectComponent
                        options={cohortesActivas(filterOptions.cohorteOptions)}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        insertValueField="descripcion"
                        selectedValue={formData.cohorte}
                        handleChange={handleChange}
                        controlId="cohorte"
                        label="Cohorte"
                        required
                    />
                    </Col>
                    <Col md={6}>

                 
                   

                    {/* Periodo Selector */}
                    {formErrors.periodo_id && (
                    <div className="text-danger">{formErrors.periodo_id}</div>
                )}
                    <SelectComponent
                        options={filterOptions.periodoOptions}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        selectedValue={formData.periodo_id}
                        handleChange={handleChange}
                        controlId="periodo_id"
                        label="Periodo"
                        required

                    />
                    </Col>
                    
                         <Col md={6}>
                    {/* Cohorte Selector */}
                    {formErrors.grupo && (
                    <div className="text-danger">{formErrors.grupo}</div>
                )}
                    <SelectComponent
                        options={filterOptions.grupoOptions}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        insertValueField="descripcion"
                        selectedValue={formData.grupo}
                        handleChange={handleChange}
                        controlId="grupo"
                        label="Grupo"
                        required
                    />
                    </Col>
                    </Row>
                     <SelectComponent
                        options={filterOptions.iniciativaOptions}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        selectedValue={formData.iniciativa_id}
                        handleChange={handleChange}
                        controlId="iniciativa_id"
                        label="Iniciativas"
                        required

                    />
                  
                            
                        <Form.Group controlId="descripcion">
                        <Form.Label>Descripción</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="descripcion"
                            value={formData.descripcion}
                            onChange={handleChange}
                        />
                        </Form.Group>

                        <div className="d-flex align-items-center gap-2 flex-wrap mt-3">


                         {/* Tabla de Datos */}
                         <Table bordered striped responsive >

        <thead>
          <tr>
            <th>Cédula</th>
            <th>Nombre</th>
            <th>Apellido</th>
            <th>Fecha Nac.</th>
            <th>Género</th>
            <th>Dirección</th>
            <th>Nivel Inst</th>
            <th>Email</th>
            <th>Tlf</th>
            <th>Superatec</th>
            <th>Limpiar</th>

          </tr>
        </thead>
        <tbody>
          {filas.map((fila, index) => (
            <tr key={index}>
              <td>
              <Form.Group controlId={`cedula-${index}`} className="custom-gutter d-flex align-items-center">
                            <input
                                type="text"
                                value={fila.cedula_identidad}
                                onChange={(event) => handleCedulaInputChange(event, index)}
                                placeholder="Cédula"
                                className="form-control flex-grow-1"
                                maxLength="9"
                            />
                            <button type="button" onClick={() => handleCedulaSearch(index)} className="btn btn-primary ms-1 px-2">
                                <i className="bi bi-search"></i>
                            </button>
                        </Form.Group>
                        {fila.errorMensaje && <div className="text-danger mt-1">{fila.errorMensaje}</div>}
                    </td>
              <td>
                <Form.Control
                  type="text"
                  name="nombres"
                  value={fila.nombres}
                  onChange={(e) => {
                    if (!filas[index].bloqueado) {
                    const nuevasFilas = [...filas];
                    nuevasFilas[index].nombres = e.target.value;
                    setFilas(nuevasFilas);
                    }
                  }}

              
                  maxLength={255}
                  placeholder="Nombre"
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  name="apellidos"
                  value={fila.apellidos}
                  onChange={(e) => {
                    if (!filas[index].bloqueado) {
                    const nuevasFilas = [...filas];
                    nuevasFilas[index].apellidos = e.target.value;
                    setFilas(nuevasFilas);
                    }
                  }}
                  maxLength={255}
                  placeholder="Apellido"
                />
              </td>
              <td>
                <Form.Control
                  type="date"
                  name="fecha_nacimiento"
                  min={FECHA_NAC_MIN}
                  max={FECHA_NAC_MAX}
                  value={fila.fecha_nacimiento}
                  onChange={(e) => {
                    if (!filas[index].bloqueado) {
                    const nuevasFilas = [...filas];
                    nuevasFilas[index].fecha_nacimiento = e.target.value;
                    setFilas(nuevasFilas);
                    }
                  }}
                />
              </td>
              <td>
                <SelectComponent
                  options={filterOptions2.generoOptions}
                  nameField="descripcion"
                  valueField="id"
                  selectedValue={fila.genero_id}
                  handleChange={(e) => {
                    if (!filas[index].bloqueado) {
                    const nuevasFilas = [...filas];
                    nuevasFilas[index].genero_id = e.target.value;
                    setFilas(nuevasFilas);
                    }
                  }}
                  controlId={`genero_id_${index}`}
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  name="direccion"
                  value={fila.direccion}
                  onChange={(e) => {
                    if (!filas[index].bloqueado) {
                    const nuevasFilas = [...filas];
                    nuevasFilas[index].direccion = e.target.value;
                    setFilas(nuevasFilas);
                    }
                  }}
                  maxLength={255}
                  placeholder="Dirección"
                />
              </td>
              <td>
                <SelectComponent
                  options={filterOptions2.nivelInstruccionOptions}
                  nameField="descripcion"
                  valueField="id"
                  selectedValue={fila.nivel_instruccion_id}
                  handleChange={(e) => {
                    if (!filas[index].bloqueado) {
                    const nuevasFilas = [...filas];
                    nuevasFilas[index].nivel_instruccion_id = e.target.value;
                    setFilas(nuevasFilas);
                    }
                  }}
                  controlId={`nivel_instruccion_id_${index}`}
                />
              </td>
              <td>
                <Form.Control
                  type="email"
                  name="email"
                  value={fila.email}
                  onChange={(e) => {
                    if (!filas[index].bloqueado) {
                    const nuevasFilas = [...filas];
                    nuevasFilas[index].email = e.target.value;
                    setFilas(nuevasFilas);
                    }
                  }}
                  placeholder="Email"
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  name="tlf_casa"
                  value={fila.tlf_casa}
                  onChange={(e) => {
                    if (!filas[index].bloqueado) {
                    const nuevasFilas = [...filas];
                    nuevasFilas[index].tlf_casa = e.target.value;
                    setFilas(nuevasFilas);
                    }
                  }}
                  maxLength={30}
                  placeholder="Tlf"
                />
              </td>
              <td>
                        <Form.Check
                            type="checkbox"
                            name="superatec"
                            checked={fila.superatec}
                            readOnly
                        />
                    </td>
                    <td>
                    <button type="button" onClick={() => limpiarFila(index)} className="btn btn-warning ms-2">
                                <i className="bi bi-brush-fill"></i>
                            </button>
                    </td>
            </tr>
            
          ))}
        </tbody>
      </Table>

      {/* Botones de Acción */}
      <div className="d-flex justify-content-between mt-3">
        <Button variant="success" onClick={agregarFila}>
          Agregar Fila
        </Button>
        <Button variant="danger" onClick={eliminarFila} disabled={filas.length === 1} className="ms-3">
             Eliminar Fila
            </Button>
      </div>
                    </div>
                            </div>

                   
                            <div className="d-flex mt-1">
                                <Button variant="info" onClick={handleInscripcion} className="mt-3 me-2">
                                    Inscribir
                                </Button>
                                <Button
                                    variant="secondary"
                                    onClick={() => navigate(-1)}
                                    className="mt-3"
                                >
                                    Volver
                                </Button>
                            </div>
                    </div>
                    </Form.Group>
                    </div>
                    <Modal show={showModal} onHide={handleCloseModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Seleccionar Patrocinante</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <div className="d-flex align-items-center">

                        <Form.Control 
                            name="rif_cedula"
                            type="text" 
                            placeholder="Buscar por Rif/Cédula" 
                            value={filtrosPatrocinante.rif_cedula}
                            onChange={handleFilterPatrocinantesChange} 
                            className="mb-3"
                        />
                        <Form.Control 
                            name="nombre_patrocinante"
                            type="text" 
                            placeholder="Buscar por Nombre" 
                            value={filtrosPatrocinante.nombre_patrocinante}
                            onChange={handleFilterPatrocinantesChange} 
                            className="mb-3"
                        />
                        <Button 
                            variant="info me-2" 
                            onClick={getAllPatrocinantes}
                            style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                        >
                            <FaSearch className="me-1" /> {/* Ícono de lupa */}
                        </Button>

                    </div>

                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Rif/Cédula</th>
                                    <th>Nombre</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                
                                {paginatedPatrocinantes.map((patrocinante) => (
                                    <tr key={patrocinante.id}>
                                        <td>{patrocinante.rif_cedula}</td>
                                        <td>{patrocinante.nombre_patrocinante}</td>
                                        <td>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <Button variant="info" onClick={() => handleSeleccionarPatrocinante(patrocinante)} className="me-2">
                                                    <i className="bi bi-check2-square"></i>
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <div className="d-flex justify-content-between mt-3">
                            <Button
                                variant="secondary"
                                onClick={() => handlePatrocinantesPageChange(currentPagePatrocinantes - 1)}
                                disabled={currentPagePatrocinantes === 1}
                            >
                                Anterior
                            </Button>
                            <Button
                                variant="secondary"
                                onClick={() => handlePatrocinantesPageChange(currentPagePatrocinantes + 1)}
                                disabled={currentPagePatrocinantes === totalPages}
                            >
                                Siguiente
                            </Button>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModal}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
</div>
        
    );
};
export default InscribirIniciativas;
